import type { Phrases } from '../../common/Phrases.d';

import React from 'react';
import { useWatch } from 'react-hook-form';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { Span } from '/react4xp/components/Element';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import {
	type When,
	ANONYMOUS_FIELD_NAME,
	WHEN,
} from '../../anonymous/constants';


export const WhenOtherTextField = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const {
		control,
	} =	useFormContext();

	const when: When = useWatch({ control, name: ANONYMOUS_FIELD_NAME.WHEN_WAS_THE_DRUG_TAKEN}) as When;
	const isOther = when === WHEN.OTHER;

	const whenLabel = phrases['notificationForm.anonymous.whenField.label'];
	const whenOtherLabel = phrases['notificationForm.term.other'];
	return (
		<TextField
			errorSummaryLabel={`${whenLabel} - ${whenOtherLabel}`}
			fullWidth
			label={<Span textSize='lg'>{whenOtherLabel}</Span>}
			name={ANONYMOUS_FIELD_NAME.WHEN_WAS_THE_DRUG_TAKEN_OTHER}
			showIf={({ watch }) => isOther}
		/>
	);
};

